import { Component, Prop, Event, EventEmitter, h } from '@stencil/core';
import { Color } from '../../interface';

@Component({
  tag: 'two-pos-controller-content',
  styleUrl: 'two-pos-controller.scss',
  shadow: false,
  scoped: false,
})
export class SlidingDoorContent {
   @Prop() color?: Color;
   @Prop() disabled: boolean;
   @Prop() mode: 'on' | 'off' | 'auto';
   @Prop() manualcontrols?: boolean;
   @Prop() min?: number;
   @Prop() max?: number;
   @Prop() step?: number;
   @Prop() setpoint: number;

   @Event() changemode!: EventEmitter<string>;
   @Event() changesetpoint!: EventEmitter<boolean>;

   render() {
    const secondaryButtonColor = (this.color) === 'dark' ? 'light' : 'dark';
    const colorClass = this.color ? `lar-color-${this.color}` : '';
    return (
      <div class={`thermostat-container ${colorClass}`}>
          <div class="temp-display">
            <div class="temp-ring"></div>
            <div class="temp-content">
              <div class="temp-value">{this.setpoint}</div>
              <div class="temp-label"><lar-translate t="twoPosController.target" /></div>
            </div>
            <div class="temp-controls">
              <lar-button
                disabled={(this.min && this.setpoint <= this.min) || this.disabled}
                color={this.color}
                onClick={() => this.changesetpoint.emit(false)}
              >
                -
              </lar-button>
              <lar-button
                disabled={(this.max && this.setpoint >= this.max) || this.disabled}
                color={this.color}
                onClick={() => this.changesetpoint.emit(true)}
              >
                +
              </lar-button>
            </div>
          </div>

          {this.manualcontrols &&
          <lar-button-group>
            <lar-button
              disabled={this.disabled}
              color={this.mode === 'on' ? this.color : secondaryButtonColor}
              onClick={() => this.changemode.emit('on')}
            >
              <lar-translate t="twoPosController.on" />
            </lar-button>
            <lar-button
              disabled={this.disabled}
              color={this.mode === 'off' ? this.color : secondaryButtonColor}
              onClick={() => this.changemode.emit('off')}
            >
              <lar-translate t="twoPosController.off" />
            </lar-button>
            <lar-button
              disabled={this.disabled}
              color={this.mode === 'auto' ? this.color : secondaryButtonColor}
              onClick={() => this.changemode.emit('auto')}
            >
              <lar-translate t="twoPosController.auto" />
            </lar-button>
          </lar-button-group>
          }
        </div>
    );
  }
}